import React, { useEffect, useState } from "react";
import { makeStyles, useTheme } from "@material-ui/core/styles";

import {
  Button,
  FormControlLabel,
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
  DialogContentText,
  Checkbox,
  InputAdornment,
  TextField
} from "@material-ui/core";

import DirectionsIcon from "@material-ui/icons/Directions";


import { formatCurrency } from "../../../functions/GlobalHelpers"


const useStyles = makeStyles((theme) => ({

}));

export default function PercentComputationHelper({ title, description, sourceKey, targetKey, defaultPercent, showOptionalTax, creditFunctions }) {
  const theme = useTheme();
  const classes = useStyles();

  const [percent, setPercent] = useState(0);
  const [addTax, setAddTax] = useState(true);
  const [open, setOpen] = useState(false);
  const [sourceValue, setSourceValue] = useState(0);

  useEffect(() => {
    setPercent(defaultPercent);
    if (!showOptionalTax)
      setAddTax(false);
  }, [defaultPercent, showOptionalTax]);

  useEffect(() => {
    if (open && sourceKey) {
      if (Array.isArray(sourceKey)) {
        let sum = 0;
        sourceKey.forEach(key => {
          const value = creditFunctions.getFirstValueByMetaKey(key);
          if (value && !isNaN(value))
            sum += parseFloat(value);
        })
        setSourceValue(sum);
      } else {
        const value = creditFunctions.getFirstValueByMetaKey(sourceKey);
        if (value && !isNaN(value))
          setSourceValue(parseFloat(value));
      }
    } else
      setSourceValue(0);

  }, [open]);

  const getResult = () => {
    if (sourceValue)
      return Math.round(sourceValue * (parseFloat(percent) * (addTax ? 1.2 : 1) / 100));

    return null;
  }

  const printResult = () => {
    const value = getResult();
    if (value) {
      return <>
        {formatCurrency(parseFloat(percent))}
        % von €
        {formatCurrency(sourceValue, 0)}
        {(addTax ? " +20% Ust." : "")}
        <br />= <strong>€ {formatCurrency(value, 0)}</strong>
      </>
    }
    return <></>
  }

  return (
    <>
      <Button
        size="small"
        onClick={() => {
          setOpen(true);
        }}
      >
        <DirectionsIcon />
        berechnen
      </Button>
      <Dialog onClose={() => { setOpen(false) }} open={open}>
        <DialogTitle>{title}</DialogTitle>
        <DialogContent>
          <DialogContentText>{description}</DialogContentText>
          <TextField
            type="number"
            value={percent}
            onChange={(e) => {
              setPercent(e.target.value);
            }}
            InputProps={{
              endAdornment: <InputAdornment position="end">%</InputAdornment>
            }}
            inputProps={{
              style: { textAlign: "right" },
              min: 0,
              max: 100,
              step: 0.1
            }}
            style={{ width: 70, marginRight: 60 }}
          />
          {showOptionalTax &&
            <FormControlLabel
              control={
                <Checkbox
                  checked={addTax}
                  onChange={(e) => {
                    setAddTax(e.target.checked);
                  }}
                  color="primary"
                />
              }
              label="zzgl. 20% Ust"
            />}
          <DialogContentText>
            {printResult()}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => { setOpen(false) }} color="primary">
            abbrechen
          </Button>
          <Button
            disabled={isNaN(getResult())}
            onClick={() => {
              creditFunctions.setValuesByMetaKey(targetKey, getResult())
              setOpen(false);
            }}
            color="primary"
            autoFocus>
            Übernehmen
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
